var map = {
	"./100.jpg": 999,
	"./100.png": 9332,
	"./BIF.jpeg": 5635,
	"./b.png": 9076,
	"./buld.jpg": 8543,
	"./cisco.png": 6032,
	"./codeInLogo.png": 7935,
	"./codeuino.jpg": 8394,
	"./coursera_logo.png": 1877,
	"./deeplearning_ai_logo.png": 2862,
	"./googleAssistant.jpg": 700,
	"./google_logo.png": 5927,
	"./hong_kong.png": 7028,
	"./icfoods.png": 2049,
	"./icl.png": 5742,
	"./ino.png": 6380,
	"./intel_logo.jpg": 3026,
	"./linuxworld.jpeg": 6305,
	"./northwestern.png": 350,
	"./osulogo.svg": 5830,
	"./quicko.jpg": 917,
	"./sal.png": 5693,
	"./stanford_logo.png": 7137,
	"./ucb.webp": 9258,
	"./ucm.png": 304,
	"./usg.png": 8302,
	"./vitlogo.jpeg": 3294,
	"./vitlogo.png": 578,
	"./wisel.jpeg": 1878,
	"./wrighter.jpg": 7039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;